export default __webpack_public_path__ + "a764d17ddae4da017e20be60f15e1092.png";